import React, { useEffect } from 'react'
import Navbar from './navbar'
import { Outlet, useNavigate } from 'react-router-dom'
import {barely} from '../../public/LoginImages/importimages'
const Dashboard = () => {
let navigate=useNavigate()

  return (
   <>
    <Navbar/> 
    <Outlet/>
    </> 
  )
}

export default Dashboard